import { Component } from '@angular/core';
import {
  SuiModal,
  ComponentModalConfig,
  ModalSize,
} from '@richardlt/ng2-semantic-ui';
import { EwalletService } from 'src/modules/features/admin/services/ewallet';


interface ICloseAccountModalContext {
  account: any;
}
@Component({
  selector: 'app-close-account-modal',
  templateUrl: './close-account-modal.component.html',
  styleUrls: ['./close-account-modal.component.scss'],
})
export class CloseAccountModalComponent {
  error: any;
  success: any;
  pending = false;

  constructor(
    public modal: SuiModal<ICloseAccountModalContext, any, any>,
    private walletService: EwalletService,
  ) {}
  formatAmount(amount: number) {
    return amount.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }
  capitalize(word: string) {
    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
  }

  deactivateAccount(balance) {
    const user = JSON.parse(localStorage.getItem('user'));
    const payload ={
      nccId: this.modal.context.account.nccId,
      currencyId: this.modal.context.account.currencyId,
      createdBy: {appUserId: user.appUserId, username: user.username, name: user.firstName},
      accountDetails: this.modal.context.account.activeBankDetails
    }
    this.walletService.deactivateAccount({body: payload}).subscribe(
      (res) => {
        this.pending = false;
        this.modal.approve(false);
      },
      (err) => {
        this.error = err.error;
        this.pending = false;
      }
    );
  }
}

export class CloseAccountModal extends ComponentModalConfig<
  ICloseAccountModalContext,
  any,
  any
> {
  constructor(
    account: any,
    size: ModalSize = ModalSize.Tiny
  ) {
    super(CloseAccountModalComponent, {account});

    this.isClosable = false;
    this.transitionDuration = 200;
    this.transition = 'slide left';
    this.size = size;
    this.isFullScreen = false;
    this.isInverted = false;
  }
}
